<template>
  <div class="buy-set-content pl16 pr16">
    <!--积分设置-->
    <div class="common-form">积分设置</div>
    <el-form-item label="是否开启积分赠送：">
      <el-radio-group v-model="form.model.isPointsGift">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="是否允许使用积分抵扣：">
      <el-radio-group v-model="form.model.isPointsDiscount">
        <el-radio :label="1">允许</el-radio>
        <el-radio :label="0">不允许</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="form.model.isPointsDiscount == 1" label="最大抵扣积分数量："
                  :rules="[{ required: true, message: ' ' }]" prop="model.maxPointsDiscount">
      <el-input type="number" min="0" v-model="form.model.maxPointsDiscount" class="max-w460"></el-input>
    </el-form-item>

    <!--称重参数设置-->
    <div class="common-form">称重参数设置</div>
    <el-form-item label="默认打印题头：" prop="model.printTitle">
      <el-input v-model="form.model.printTitle" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="打印的手机号：" prop="model.printPhone">
      <el-input v-model="form.model.printPhone" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="免费打印次数：" prop="model.printLimits" :rules="[{ required: true, message: ' ' }]">
      <el-input type="number" min="0" v-model="form.model.printLimits" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="打印价格：" prop="model.printLimits" :rules="[{ required: true, message: ' ' }]">
      <template slot="label">
            <span>打印价格
              <el-tooltip class="item" effect="dark" placement="right">
                <i class="el-icon-question" style="font-size: 16px; vertical-align: middle;"></i>
                <div slot="content">
                  <p>超过免费打印次数收费价格，单位元</p>
                </div>
              </el-tooltip>
            </span>
      </template>
      <el-input type="number" min="0" v-model="form.model.printPrice" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="计量单位：" :rules="[{ required: true, message: ' ' }]">
      <el-select v-model="form.model.unit" placeholder="请选择计量单位" clearable size="small">
        <el-option v-for="dict in this.getDictDatas(DICT_TYPE.UNIT_MEASUREMENT)"
                   :key="dict.value" :label="dict.label" :value="dict.value"/>
      </el-select>
    </el-form-item>
    <el-form-item label="用户端称重隐藏的位数："
                  prop="model.hideLength"
                  :rules="[{ required: true, message: ' ' }]">
      <el-input type="number" min="0" max="10" v-model="form.model.hideLength" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="打印的项目" prop="model.printItems" :rules="[{ required: true, message: ' ' }]">
      <el-tooltip class="item" effect="dark" placement="top-start">
        <div slot="content">1、默认全部打印，不勾选则不打印该项目
        </div>
        <el-checkbox-group v-model="form.model.printItems">
          <el-checkbox-button key="printType" label="printType">次数</el-checkbox-button>
          <el-checkbox-button key="title" label="title">标题</el-checkbox-button>
          <el-checkbox-button key="createTime" label="createTime">时间</el-checkbox-button>
          <el-checkbox-button key="grossWeight" label="grossWeight">毛重</el-checkbox-button>
          <el-checkbox-button key="tareWeight" label="tareWeight">皮重</el-checkbox-button>
          <el-checkbox-button key="netWeight" label="netWeight">净重</el-checkbox-button>
          <el-checkbox-button key="carNum" label="carNum">车牌号</el-checkbox-button>
          <el-checkbox-button key="itemName" label="itemName">货物名称</el-checkbox-button>
          <el-checkbox-button key="url" label="url">二维码内容</el-checkbox-button>
          <el-checkbox-button key="organizationName" label="organizationName">公司名称</el-checkbox-button>
          <el-checkbox-button key="driverName" label="driverName">驾驶员</el-checkbox-button>
          <el-checkbox-button key="driverMobile" label="driverMobile">联系方式</el-checkbox-button>
          <el-checkbox-button key="weightType" label="weightType">称重类型</el-checkbox-button>
        </el-checkbox-group>
      </el-tooltip>
    </el-form-item>

    <el-form-item label="称重类型" prop="model.weightTypes" :rules="[{ required: true, message: ' ' }]">
      <el-tooltip class="item" effect="dark" placement="top-start">
        <div slot="content">1、默认全部打印，不勾选则不展示该类型
        </div>
        <el-checkbox-group v-model="form.model.weightTypes">
          <el-checkbox-button key="1" label="1">单次称重</el-checkbox-button>
          <el-checkbox-button key="2" label="2">两次称重</el-checkbox-button>
        </el-checkbox-group>
      </el-tooltip>
    </el-form-item>

    <el-form-item label="两次称重付款类型" prop="model.twiceType"
                  :rules="[{ required: true, message: ' ' }]">
      <template slot="label">
            <span>两次称重付款类型
              <el-tooltip class="item" effect="dark" placement="right">
                <i class="el-icon-question" style="font-size: 16px; vertical-align: middle;"></i>
                <div slot="content">
                  <p>自动判断支付次数说明：如果首次为毛重，第二次不用支付；如果首次为皮重，第二次补齐毛重费用</p>
                  <br>
                </div>
              </el-tooltip>
            </span>
      </template>
      <el-radio-group v-model="form.model.twiceType">
        <el-radio :label="10">支付两次退一次</el-radio>
        <el-radio :label="20">支付首次，第二次有效时间内免费</el-radio>
        <el-radio :label="30">支付首次，第二次无需支付</el-radio>
        <el-radio :label="40">首次无需支付，第二次需支付</el-radio>
        <el-radio :label="50">自动判断支付次数</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="最大皮重："
                  prop="model.maxTareWeight"
                  :rules="[{ required: true, message: ' ' }]">
      <template slot="label">
            <span>最大皮重
              <el-tooltip class="item" effect="dark" placement="right">
                <i class="el-icon-question" style="font-size: 16px; vertical-align: middle;"></i>
                <div slot="content">
                  <p>最大皮重计量单位参照上面的计量单位字段，默认为千克</p>
                  <br>
                  <p>该字段用于两次称重：</p>
                  <p>如果两次重量中最小重量超过该值：两次均收费,且不退费。</p>
                  <p>如果两次重量中最小重量没有超过该值：退最小重量费用。</p>
                  <p>例子：设置0.00001即可都不退</p>
                  <p>例子：设置0即必须退一次</p>
                </div>
              </el-tooltip>
            </span>
      </template>
      <el-input type="number" min="0" v-model="form.model.maxTareWeight" class="max-w460"></el-input>
      KG
    </el-form-item>

    <el-form-item label="有效时长："
                  prop="model.effectiveDuration"
                  :rules="[{ required: true, message: ' ' }]">
      <template slot="label">
            <span>有效时长
              <el-tooltip class="item" effect="dark" placement="right">
                <i class="el-icon-question" style="font-size: 16px; vertical-align: middle;"></i>
                <div slot="content">
                  <p>单位秒</p>
                  <br>
                  <p>该字段用于两次称重：</p>
                  <p>有效时间内，第二次称重免费。</p>
                </div>
              </el-tooltip>
            </span>
      </template>
      <el-input type="number" min="0" v-model="form.model.effectiveDuration" class="max-w460"></el-input>
      秒
    </el-form-item>

    <el-form-item label="首次称重订单" prop="model.twiceDays">
      <el-input v-model="form.model.twiceDays" type="number" style="width: 200px;"></el-input>
      天内允许二次称重
      <div class="tips">
        首次称重订单完成后 ，用户在n天内可以继续二次称重订单，设置0天不限制时长
      </div>
    </el-form-item>

    <el-form-item label="限重："
                  prop="model.weightLimit"
                  :rules="[{ required: true, message: ' ' }]">
      <template slot="label">
            <span>限重
              <el-tooltip class="item" effect="dark" placement="right">
                <i class="el-icon-question" style="font-size: 16px; vertical-align: middle;"></i>
                <div slot="content">
                  <p>单位KG</p>
                  <br>
                  <p>地磅仪表的最大量程</p>
                </div>
              </el-tooltip>
            </span>
      </template>
      <el-input type="number" min="0" v-model="form.model.weightLimit" class="max-w460"></el-input>
      KG
    </el-form-item>

    <el-form-item label="超载允许支付："
                  prop="model.isOverloadPay">
      <el-checkbox v-model="form.model.isOverloadPay">是</el-checkbox>
    </el-form-item>

    <el-form-item label="支付完成自动打印："
                  prop="model.isAutoPrint">
      <el-checkbox v-model="form.model.isAutoPrint">是</el-checkbox>
    </el-form-item>

    <el-form-item label="允许多次称重："
                  prop="model.isMultiple">
      <template slot="label">
            <span>允许多次称重
              <el-tooltip class="item" effect="dark" placement="right">
                <i class="el-icon-question" style="font-size: 16px; vertical-align: middle;"></i>
                <div slot="content">
                  <p>支付一次允许多次称重</p>
                  <br>
                  <p>地磅仪表的最大量程</p>
                </div>
              </el-tooltip>
            </span>
      </template>
      <el-checkbox v-model="form.model.isMultiple ">是</el-checkbox>
    </el-form-item>

  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {

  },
  inject: ['form'],
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/Buyset.vue